import { FC } from 'react'
import { useTranslation, Trans } from 'react-i18next'

import { APP_MODE } from '@shared/config/appMode/appMode'
import { useAppModeStore } from '@shared/config/appMode.store'

import { footerConfig } from './config'
import styles from './footer.module.css'
import { typographyColor, typographyType, typographyAs } from '../typography/constants'
import Typography from '../typography/Typography'


const Footer: FC<{ isUk: boolean; }> = ({ isUk }) => {
    const { t } = useTranslation()
    const appMode = useAppModeStore(s => s.mode)

    const currentYear = new Date().getFullYear()

    const legalItems = isUk ? footerConfig[appMode].footerItems.slice(0, -1) : footerConfig[appMode].footerItems

    const legalHost = isUk ? import.meta.env.VITE_BANXE_UK_PATH : import.meta.env.VITE_BANXE_COM_PATH

    const legalLinks = footerConfig[appMode].legalLinks
        .slice(0, isUk ? -1 : undefined)
        .map(item => ({
            ...item,
            href: appMode !== APP_MODE.NEURONEXT ? `${legalHost}${item.href}` : item.href,
        }))

    return (
        <footer className={styles.footer}>
            <div className={styles.search}>
                <div className={styles.legalContent}>
                    {legalLinks.map((link, idx) => (
                        <a
                            key={idx}
                            href={link?.href}
                            className={styles.legalContentItem}
                        >
                            <Typography
                                type={typographyType.link}
                                color={typographyColor.tertiary}
                                as={typographyAs.span}
                                className={styles.legalLink}
                            >
                                {t(link?.title)}
                            </Typography>
                        </a>
                    ))}
                </div>
            </div>
            <hr className={styles.line} />
            <div className={styles.additional}>
                <Typography
                    type={typographyType.caption}
                    color={typographyColor.secondaryInverted}
                >
                    {t(footerConfig[appMode].copyright, { year: currentYear })}
                </Typography>
                {legalItems?.map((item, index) => (
                    <Typography
                        key={index}
                        type={typographyType.caption}
                        color={typographyColor.secondaryInverted}
                    >
                        {t(item)}
                    </Typography>
                ))
                }
                { appMode === 'default' &&
                <Typography
                    type={typographyType.caption}
                    color={typographyColor.secondaryInverted}
                >
                    <Trans
                        i18nKey="footer.our_personal_and_business_pricing"
                        components={{
                            personalLink: (
                                <a
                                    href="https://static.banxe.com/files/docs/personal_pricing.pdf"
                                    target="_blank"
                                    style={{ textDecoration: 'underline' }}
                                />
                            ),
                            businessLink: (
                                <a
                                    href="https://static.banxe.com/files/docs/business_pricing.pdf"
                                    target="_blank"
                                    style={{ textDecoration: 'underline' }}
                                />
                            ),
                        }}
                    />
                </Typography>
                }
            </div>
        </footer>
    )
}

export default Footer

